import { currencyOptions } from 'constant';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Expenditure from '../../Expenditure';

function ExpenditureInfo({ generalInfoData, expenditureData }) {
  const { t } = useTranslation();

  return (
    <div className="flex text-lg mt-2 flex-column">
      <h4>{t('projectProposal.general.totalExpenditure.label')}</h4>
      <div className="flex ml-5 flex-column">
        <div>
          <span className="font-semibold">
            {t('projectProposal.general.totalExpenditure.total')}:{' '}
          </span>
          {generalInfoData?.totalExpenditure?.toLocaleString('vi', currencyOptions)},{' '}
          {t('projectProposal.general.totalExpenditure.includes')}:
        </div>
        <div className="mt-1 ml-4">
          <span className="font-semibold">
            {t('projectProposal.general.totalExpenditure.fromVnu')}:{' '}
          </span>
          {generalInfoData?.nationalUniversityTotalExpenditure?.toLocaleString(
            'vi',
            currencyOptions
          )}
        </div>
        <div className="mt-1 ml-4 font-italic">
          {t('projectProposal.general.totalExpenditure.inParticular')}:
        </div>
        <div className="ml-5 font-italic">
          <div className="mt-1 ml-2">
            <span className="font-semibold">
              {t('projectProposal.general.totalExpenditure.allocatedAdministrative')}
            </span>
            [
            <span style={{ color: 'red' }}>
              {t('projectProposal.general.totalExpenditure.item')} 1 +{' '}
              {t('projectProposal.general.totalExpenditure.item')} 3 +{' '}
              {t('projectProposal.general.totalExpenditure.item')} 4
            </span>
            ]:{' '}
            {generalInfoData?.nationalUniversityAllocatedExpenditure?.toLocaleString(
              'vi',
              currencyOptions
            )}
          </div>
          <div className="mt-1 ml-2">
            <span className="font-semibold">
              {t('projectProposal.general.totalExpenditure.nonAllocatedAdministrative')}
            </span>
            [{t('projectProposal.general.totalExpenditure.item')} 2]:{' '}
            {generalInfoData?.nationalUniversityNonallocatedExpenditure?.toLocaleString(
              'vi',
              currencyOptions
            )}{' '}
          </div>
        </div>
        <div className="mt-1 ml-4">
          <span className="font-semibold">
            {t('projectProposal.general.totalExpenditure.fromFunding')}:{' '}
          </span>
          {generalInfoData?.fundingExpenditure?.toLocaleString('vi', currencyOptions)},{' '}
        </div>
        <div className="mt-1 ml-4 font-italic">
          {t('projectProposal.general.totalExpenditure.inParticular')}:
        </div>
        <div className="flex text-lg mr-5 ml-2 font-italic">
          <div className="mt-1 ml-5 w-15rem">
            <span className="font-semibold">
              {t('projectProposal.general.totalExpenditure.ownCapital')}:{' '}
            </span>
            {generalInfoData?.fundingExpenditureSelf?.toLocaleString('vi', currencyOptions)}
          </div>
        </div>
        <div className="flex text-lg mb-2 mr-5 ml-2 font-italic">
          <div className="mt-1 ml-5 w-15rem">
            <span className="font-semibold">
              {t('projectProposal.general.totalExpenditure.otherCapital')}:{' '}
            </span>
            {generalInfoData?.fundingExpenditureOther?.toLocaleString('vi', currencyOptions)}
          </div>
        </div>
        {generalInfoData?.bonusExpenditure > 0 && (
          <div className="mt-1">
            <span className="font-semibold">
              {t('projectProposal.general.totalExpenditure.bonusExpenditure')}:{' '}
            </span>
            {generalInfoData?.bonusExpenditure?.toLocaleString('vi', currencyOptions)}
          </div>
        )}
        <div className="mt-1 mb-2">
          <div>
            <span className="font-semibold">
              {t('projectProposal.general.totalExpenditure.otherFunding')}:{' '}
            </span>
          </div>
          <p>{generalInfoData?.otherSponsorOrganization}</p>
        </div>
      </div>
      <Expenditure data={expenditureData} />
    </div>
  );
}

ExpenditureInfo.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  generalInfoData: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  expenditureData: PropTypes.object.isRequired,
};

export default ExpenditureInfo;
